export var LocaleTypes;
(function (LocaleTypes) {
    LocaleTypes["BRAZIL"] = "pt-br";
    LocaleTypes["AUSTRALIA"] = "en-au";
    LocaleTypes["BOLIVIA"] = "es-bo";
    LocaleTypes["MEXICO"] = "es-mx";
    LocaleTypes["ARGENTINA"] = "es-ar";
    LocaleTypes["COLOMBIA"] = "es-co";
})(LocaleTypes || (LocaleTypes = {}));
//# sourceMappingURL=locale-types.js.map